import React, { useState, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { format } from "date-fns";
//api
import { createUser } from 'api/users';
//components
import Title from 'components/backoffice/texts/title';
import UserForm from 'components/backoffice/forms/userForm';

const CreateUser = () => {
  const [loading, setLoading] = useState(false);
  const [backendErrors, setBackendErrors] = useState({})
  const { t } = useTranslation(['backoffice']);
  const navigate = useNavigate();
  const { title, setTitle } = useOutletContext()
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    is_active: false,
    profile: '',
    job: '',
    supervisor: false,
    margin_library: '',
    margin_bookstore: '',
    dni: '',
    phone_number: '',
    date_birth: '',
    benefited_bookstore: '',
    library: '',
    username: '',
    is_administrator: false
  });

  useEffect(() => {
    setTitle(t('createuser'))
    return () => {
      setTitle('');
    };
  }, [title])

  const onSubmit = useCallback(async (values) => {
    setLoading(true);
    const data = {
      password: values.password,
      email: values.email,
      first_name: values.first_name,
      last_name: values.last_name,
      is_active: values.is_active,
      username: values.username,
      profile: values.profile,
    };
    switch (values.profile) {
      case 'normal':
        data['benefited_bookstore'] = {
          value: parseInt(values.benefited_bookstore)
        }
        data['dni'] = values.dni
        data['phone_number'] = values.phone_number
        data['date_birth'] = format(values?.date_birth, 'yyyy-MM-dd')
        break;
      case 'worker':
        data['job'] = values.job
        data['supervisor'] = values.supervisor
        data['is_administrator']= values.is_administrator
        break;
      case 'commercial':
        data['margin_library'] = values.margin_library
        data['margin_bookstore'] = values.margin_bookstore
        break;
      case 'library':
        data['library'] = values.library.id
        break;
      default:
        break;
    }
    try {
      const response = await createUser(data);
      if (response.status === 201) {
        toast.success(t('creadocorrectamente'));
        navigate('/intranet/users', { replace: true });
      } else if (response?.status === 400 && response?.data) {
        setBackendErrors(response?.data);
        setFormData(values);
      } else {
        toast.error(`${t('error')} ${response.status}: ${t('mensajeerror')}`, { theme: 'colored' });
      }
    } catch (error) {
      console.log(error)
    }
    setLoading(false);
  }, []);

  return (
    <div className="mt-2">
      <Title text={t('createuser')} />
      <UserForm
        loading={loading}
        isEditing={false}
        onSubmitForm={onSubmit}
        defaultValues={formData}
        backendErrors={backendErrors}
      />
    </div>
  );
};

export default CreateUser;
